import script from "./CustomDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./CustomDropdown.vue?vue&type=style&index=0&id=6245981f&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6245981f"]])

export default __exports__